export default {
  contact: "candidate/profile/contact",
};
